import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Privacy from './pages/Privacy';
import Conduct from './pages/Conduct';
import Terms from './pages/Terms';
import Returns from './pages/Returns';
import Courses from './pages/Courses';
import SpecificCourse from './pages/SpecificCourse';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
const domain = process.env.REACT_APP_AUTH0_DOMAIN
const client = process.env.REACT_APP_AUTH0_CLIENT_ID

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/privacy-policy",
    element: <Privacy />,
  },
  {
    path: "/code-of-conduct",
    element: <Conduct />,
  },
  {
    path: "/terms-conditions",
    element: <Terms />,
  },
  {
    path: "/returns",
    element: <Returns />,
  },
  {
    path: "/courses/",
    element: <Courses />,
  },
  {
    path: "/course/:name",
    element: <SpecificCourse />
  }
]);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={client}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <RouterProvider router={router} />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
